import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Badge,
  Box,
  Checkbox,
  FormControlLabel,
  ListItem,
  Typography,
  useTheme,
} from "@mui/material";
import { Tag_Icon } from "@platformx/shared/static-assets";
import { useState } from "react";
import useGalleryStyle from "./ContentGallery.styles";

const GalleryLeftSideBar = ({
  categoriesdata,
  updateTagField,
  selectedTags,
  allowed_collection,
  allowed_content,
  allowedCDPTags = [],
  selectedCDPTags,
}) => {
  // Choose only selected Tags
  const updatedSelectedTags: any = [
    ...allowedCDPTags.filter((tag) => selectedCDPTags.includes(tag)),
    ...selectedTags,
  ];
  const [count, setCount] = useState(10);
  const [isViewLess, setIsViewLess] = useState(false);
  const classes = useGalleryStyle();

  const getUpdatedCatogories = () => {
    // Input validation
    if (!categoriesdata || !categoriesdata.category || !Array.isArray(categoriesdata.tags)) {
      return { category: "", tags: [] };
    }

    const categoryName = categoriesdata.category.toLowerCase();
    const originalTags = [...categoriesdata.tags]; // Create immutable copy

    // Handle Content Type category
    if (categoryName === "content type") {
      let filteredTags: string[] = [];
      // For other types, use allowed_content to filter tags
      filteredTags =
        allowed_content?.length > 0
          ? originalTags.filter((tag) => allowed_content.includes(tag))
          : []; // Return no tags if allowed_content is empty

      return {
        ...categoriesdata,
        tags: filteredTags,
      };
    }

    // Handle Collection category
    if (categoryName === "collection") {
      let filteredTags: string[] = [];
      // For other types, use allowed_collection to filter tags
      filteredTags =
        allowed_collection?.length > 0
          ? originalTags.filter((tag) => allowed_collection.includes(tag))
          : []; // Return no tags if allowed_collection is empty

      return {
        ...categoriesdata,
        tags: filteredTags,
      };
    }
    return { ...categoriesdata };
  };

  const updatedCategoriesData = getUpdatedCatogories();

  const setViewMoreTagCount = (tagLength) => {
    setCount(tagLength);
    setIsViewLess(true);
  };

  const setViewLessTagCount = (tagLength) => {
    setCount(tagLength);
    setIsViewLess(false);
  };

  const findSelectedTag = (tag) => {
    return updatedSelectedTags?.includes(tag);
  };

  const getTagCount = () => {
    const { tags } = updatedCategoriesData;
    if (tags?.length > 0) {
      return tags.reduce((acc, item) => {
        // eslint-disable-next-line no-param-reassign
        if (updatedSelectedTags?.includes(item)) acc += 1;
        return acc;
      }, 0);
    }
    return 0;
  };

  const tagCount = getTagCount();
  const theme = useTheme();

  return (
    <Box className={classes.menuAccordianWp}>
      {updatedCategoriesData?.tags?.length > 0 ? (
        <Accordion
          className='accordianWp'
          id={`${updatedCategoriesData?.category?.toLowerCase()}-tag-listing`}
          sx={{
            ".Platform-x-Paper-root.Platform-x-Paper-elevation": {
              borderRadius: "0px !important",
            },
          }}>
          <AccordionSummary
            className='accordianSummaryWp'
            expandIcon={<KeyboardArrowRightIcon />}
            aria-controls='panel1a-content'
            id='panel1a-header'
            sx={{
              ".Platform-x-Paper-root.Platform-x-Paper-elevation": {
                borderRadius: "0px !important",
              },
              ".Platform-x-AccordionSummary-content": {
                margin: "8px 0",
                padding: "0px 20px 0px 20px",
                // "&.Mui-expanded": {
                //   margin: "12px 0",
                // },
              },
            }}>
            {tagCount > 0 ? (
              //  <Grid>
              <Box
                sx={{
                  width: "-webkit-fill-available",
                  display: "flex",
                  alignItems: "center",
                }}>
                <Box
                  sx={{
                    width: "fit-content",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    paddingRight: "10px",
                  }}>
                  <img src={Tag_Icon} alt='TagIcon' />
                </Box>
                <Typography variant='h5medium'>{updatedCategoriesData.category}</Typography>
                <Badge
                  classes={{ badge: classes.customBadge }}
                  sx={{
                    margin: "0 0 0 1rem",
                  }}
                  badgeContent={tagCount}></Badge>
              </Box>
            ) : (
              <Box
                sx={{
                  width: "-webkit-fill-available",
                  display: "flex",
                  alignItems: "center",
                }}>
                <Box
                  sx={{
                    width: "fit-content",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    paddingRight: "10px",
                  }}>
                  <img src={Tag_Icon} alt='TagIcon' />
                </Box>
                <Typography variant='h5medium'>{updatedCategoriesData.category}</Typography>
              </Box>
            )}
          </AccordionSummary>
          <AccordionDetails
            sx={{
              padding: "0px 20px 0px 20px",
              ".Platform-x-Paper-root.Platform-x-Paper-elevation": {
                borderRadius: "0px !important",
              },
            }}>
            {[...(updatedCategoriesData?.tags || [])]
              .sort()
              ?.slice(0, count)
              ?.map((tag, index1) => {
                return (
                  <ListItem
                    key={index1}
                    sx={{
                      display: "inline-flex",
                      width: "auto",
                      padding: "0px",
                      marginBottom: "12px",
                    }}>
                    <FormControlLabel
                      value={tag || ""}
                      className='vod-cat'
                      control={
                        <Checkbox
                          checked={findSelectedTag(tag)}
                          icon={<CheckCircleOutlineIcon />}
                          checkedIcon={<CheckCircleOutlineIcon />}
                          inputProps={{ id: updatedCategoriesData.category }}
                        />
                      }
                      label={tag}
                      labelPlacement='start'
                      onChange={(e) => updateTagField(e)}
                      checked={findSelectedTag(tag)}
                    />
                    {count === index1 + 1 && updatedCategoriesData.tags.length > count && (
                      <Typography
                        onClick={() => setViewMoreTagCount(updatedCategoriesData.tags.length)}
                        variant='p3medium'
                        sx={{
                          color: theme?.palette?.customColor?.TERTIARY,
                          textDecoration: "underline",
                          cursor: "pointer",
                        }}>
                        View More
                      </Typography>
                    )}
                    {count === index1 + 1 && isViewLess && (
                      <Typography
                        onClick={() => setViewLessTagCount(10)}
                        variant='p2medium'
                        sx={{
                          color: "#374fd5",
                          textDecoration: "underline",
                          cursor: "pointer",
                        }}>
                        View Less
                      </Typography>
                    )}
                  </ListItem>
                );
              })}
          </AccordionDetails>
        </Accordion>
      ) : (
        ""
      )}
    </Box>
  );
};

export default GalleryLeftSideBar;
